document.addEventListener("readystatechange", function() {
  if ( document.readyState === "complete" ) {
    loadGlobalFunction();
  }
});

function loadGlobalFunction() {

  // debounce function

  window.debounce = function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  // sticky header
  
  const topBannerHeight =
    document.getElementsByClassName("ae--top-banner").length > 0
      ? document.querySelector(".ae--top-banner").clientHeight
      : 30;
  
  const body = document.querySelector("body");
  
  window.addEventListener("scroll", () => {
    if (window.scrollY > topBannerHeight) {
      body.classList.add("is-header-sticky");
    } else {
      body.classList.remove("is-header-sticky");
    }
  });
  
  // mobile menu variables
  
  const mobileMenuCtrl = document.querySelector(".ae--header_mobile_menu_ctrl");
  const mobileMenuContainer = document.querySelector(".ae--mobile-menu");
  const mobileMenuDropdownCtrls = document.querySelectorAll(
    ".ae--mobile-menu_megamenu_ctrl"
  );
  const mobileMenuDropdownClose = document.querySelectorAll(
    ".ae--mobile-menu_megamenu_close"
  );
  
  // open mobile menu function
  
  mobileMenuCtrl.addEventListener("click", () => {
    if (mobileMenuCtrl.classList.contains("is-active")) {
      mobileMenuCtrl.classList.remove("is-active");
      mobileMenuContainer.classList.remove("is-open");
      document.querySelector("body").classList.remove("mobile-menu-opened");
    } else {
      mobileMenuCtrl.classList.add("is-active");
      mobileMenuContainer.classList.add("is-open");
      document.querySelector("body").classList.add("mobile-menu-opened");
    }
  });
  
  // open mobile menu dropdown function
  
  mobileMenuDropdownCtrls.forEach((elem) => {
    elem.addEventListener("click", () => {
      const getMenuID = elem.getAttribute("data-mobile-menu-dropdown");
      document.getElementById(getMenuID).classList.add("is-open");
    });
  });
  
  // close mobile menu dropdown function
  mobileMenuDropdownClose.forEach((elem) => {
    elem.addEventListener("click", () => {
      elem.closest(".ae--header-megamenu_inner").classList.remove("is-open");
    });
  });
  
  // footer accordion
  const footerAccordionCtrl = document.getElementById("ae--footer-accordion");
  if ( footerAccordionCtrl != undefined ) {
    footerAccordionCtrl.addEventListener("click", () => {
      const targetAccordionTarget = footerAccordionCtrl.getAttribute("data-target");
      console.log(targetAccordionTarget);
      if (footerAccordionCtrl.classList.contains("is-open")) {
        footerAccordionCtrl.classList.remove("is-open");
        document.getElementById(targetAccordionTarget).style.height = 0;
      } else {
        footerAccordionCtrl.classList.add("is-open");
        document.getElementById(targetAccordionTarget).style.height = "120px";
      }
    });
  }
  
  // scroll to section
  
  if ( document.getElementById("scrollTo") != undefined ) {
    document.getElementById("scrollTo").addEventListener("click", (event) => {
      const targetElement = event.target.dataset.scrollTo;
      const stickyHeaderHeight = document.querySelector(".ae--header").clientHeight;
      const top = ( document.querySelector(`.${targetElement}`).getBoundingClientRect().top + window.scrollY ) - stickyHeaderHeight;
  
      window.scroll( {
        top: top,
        behavior: "smooth"
      } )
    });
  }

  // More option button on PLP temp code
  const moreOption = document.querySelectorAll(".js-go-to-pdp");
  moreOption.forEach((option) => {
      option.addEventListener("click", (event) => {
        event.preventDefault();
        window.location.href = option.getAttribute("data-url");
      }
    )
  });
}
